import { ArrowRight, Phone } from "lucide-react";
import { useQuote } from "../lib/quoteContext";
import { SITE } from "../lib/site";

export default function CTASection() {
  const { openQuote } = useQuote();
  return (
    <section className="py-16 lg:py-24 bg-[#FAFAFA]" data-testid="cta-section">
      <div className="max-w-[1280px] mx-auto px-5 sm:px-8 lg:px-10">
        <div className="relative bg-[#DCEBFB] rounded-[28px] px-6 sm:px-12 lg:px-20 py-14 lg:py-20 overflow-hidden">

          <div className="relative text-center max-w-[700px] mx-auto">
            <p className="tc-eyebrow mb-3">Ready When You Are</p>
            <h2 className="font-serif text-[30px] sm:text-[40px] lg:text-[48px] text-[#173B86] leading-[1.08] tracking-[-0.01em]">
              Want to order a cleaning service with a 20% discount?
            </h2>
            <p className="text-[14.5px] sm:text-[15px] text-[#1A2B4A]/85 mt-4">
              Tell me about your home and get your quote today. Honest pricing,
              no pressure, no surprises.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center mt-7">
              <button
                onClick={() => openQuote()}
                className="tc-btn-primary inline-flex items-center justify-center gap-2"
                data-testid="cta-section-quote"
              >
                Request a Quote <ArrowRight className="w-4 h-4" />
              </button>
              <a
                href="https://wa.me/48572410075"
                target="_blank"
                rel="noopener noreferrer"
                className="tc-btn-outline inline-flex items-center justify-center gap-2"
                data-testid="cta-section-whatsapp"
              >
                <Phone className="w-4 h-4" /> Call me on WhatsApp
              </a>
            </div>
            <p className="text-[12px] text-[#5b6a85] mt-3">
              Usually responds within 1 hour
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
